import "antd/dist/antd.css";
import './App.css';
import './MainWindow.css';
import { useEffect } from "react";
import Profile from "./pages/profile";
import Post from "./pages/post";
import Home from './pages/home'
import {BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Topbar from "./components/Topbar";
import { isBrowser } from 'react-device-detect';
import Notifications from './pages/notifications'
import { useAccount } from 'wagmi';
import About from './pages/about';
import Landing from './pages/landing';
import Projects from './pages/projects';
import SmallChains from './pages/smallchains';

function AppContent({ address, isConnected }) {
  const location = useLocation();
  const professionalRoutes = ['/', '/about', '/projects', '/smallchains'];
  const isProfessionalRoute = professionalRoutes.includes(location.pathname);
  const mainWindowClass = [
    'MainWindow',
    !isBrowser ? 'MainWindow-mobile' : '',
    isProfessionalRoute ? 'MainWindow-professional' : ''
  ].filter(Boolean).join(' ');

  useEffect(() => {
    const animationFrame = window.requestAnimationFrame(() => {
      if (location.hash) {
        const target = document.getElementById(location.hash.slice(1));

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }

      window.scrollTo({ top: 0, behavior: 'auto' });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [location.pathname, location.hash]);

  return (
    <>
      <div className={mainWindowClass}>
        <Routes>
          <Route path="/post/:postid" element={<Post />} />
          <Route exact path="/" element={<Landing />} />
          <Route path="/blog" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/smallchains" element={<SmallChains />} />
          <Route path="/profile/:wallet" element={<Profile />} />
          {isConnected && address?<Route path="/notifications" element={<Notifications key={0}/* {user.get('latestviewblock')} */ blockNumber={0}/* {user.get('latestviewblock')} */ walletAddress={address} />} />:""}
        </Routes>
      </div>
      <Topbar />
    </>
  );
}

function App() {
  const { address, isConnected } = useAccount()

  return (
    <div className="App">
      <Router>
        <AppContent address={address} isConnected={isConnected} />
      </Router>
    </div>
  );
}

export default App;
